<template>
  <div ref="quantidadeOSChart" @update-charts="update" />
</template>

<script>
import ApexCharts from 'apexcharts';
import { i18n } from '@/modules/localization/index.js';
import eventbus from '@/modules/core/services/eventbus';
import estatisticasChartsDefaultOptions from './estatisticasChartsDefaultOptions';
export default {
  props: {
    loading: { type: Boolean, required: true },
  },
  data: () => ({
    quantidadeOSChart: null,
    options: estatisticasChartsDefaultOptions,
  }),
  mounted() {
    this.quantidadeOSChart = new ApexCharts(this.$refs.quantidadeOSChart, this.options);
    this.quantidadeOSChart.render();
    eventbus.on('update-charts', this.update);
  },
  unmounted() {
    this.quantidadeOSChart.destroy();
    eventbus.off('update-charts', this.update);
  },
  methods: {
    async update(chartsData) {
      const faixa = chartsData.pagantesQuantidadeOSPorFaixa.map((x) => x.faixa);
      const quantidade = chartsData.pagantesQuantidadeOSPorFaixa.map((x) => x.quantidade);
      this.quantidadeOSChart.updateOptions({
        plotOptions: {
          bar: {
            barHeight: '80%',
          },
        },
        chart: {
          type: 'bar',
          height: 350,
        },
        title: {
          text: i18n.global.t('qtdContasPorOS'),
        },
        series: [{ name: i18n.global.t('qtdContasPorOS'), data: quantidade }],
        xaxis: {
          categories: faixa,
          labels: {
            show: false,
          },
        },
      });
    },
  },
};
</script>
